module.exports = __webpack_public_path__ + "img/afternoon-results-2.04b1d96a.png";